import React, { useEffect } from 'react';
import type { RefObject } from 'react';
import type { ExtendedHotelInfo } from 'src/components/YandexMap/types';
import HotelRenderer from 'src/routes/SearchPage/containers/HotelRenderer';
import styled, { css, keyframes } from 'styled-components';
import { pushHotelClicked, pushMapHotelCardPopup } from '../../analytics';

type HotelPopupProps = {
  isMobile: boolean;
  popupData?: ExtendedHotelInfo;
  popupRef?: RefObject<HTMLDivElement>;
  isExpandable: boolean;
  isExpanded: boolean;
  onClosePopup: () => void;
};

const HotelPopup = (props: HotelPopupProps) => {
  const {
    isMobile,
    popupData,
    popupRef,
    isExpandable,
    isExpanded,
    onClosePopup,
  } = props;

  useEffect(() => {
    if (popupData?.state) {
      pushMapHotelCardPopup(isMobile, popupData.state);
    }
  }, [popupData]);

  return (
    <PopupWrapper
      ref={popupRef}
      $isMobile={isMobile}
      $isExpandedMap={isExpanded}
      $isExpandableMap={isExpandable}
      onClick={() => pushHotelClicked()}
    >
      {popupData ? (
        <HotelRenderer
          isMapCard
          isMobile={isMobile}
          hotelInfo={popupData.hotelInfo}
          defaultImages={popupData.hotelInfo?.hotel.images}
          onClosePopup={onClosePopup}
        />
      ) : null}
    </PopupWrapper>
  );
};

const slideIn = keyframes`
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const PopupWrapper = styled.div<{
  $isMobile: boolean;
  $isExpandedMap: boolean;
  $isExpandableMap: boolean;
}>`
  animation: ${slideIn} 0.5s;

  position: absolute;
  z-index: 1;
  bottom: 0;
  right: 0;
  ${({ $isMobile, $isExpandedMap, $isExpandableMap }) =>
    $isMobile
      ? css`
          z-index: 11001;
          top: auto;
          bottom: 0px;
          left: 0;
          right: 0;
          position: fixed !important;
        `
      : css`
          scale: 0.8;
          translate: 70px 10px;
          top: auto !important;
          right: 15px !important;
          bottom: 20px !important;
          left: auto !important;
          justify-content: end;
          max-width: 650px;
          width: 100%;

          ${!$isExpandedMap &&
          $isExpandableMap &&
          css`
            width: calc(125% - 30px);
          `}
        `}
`;

export default HotelPopup;
